import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { site } from '../data/landing';
export function Footer() {
  return <footer className="bg-ink py-10 text-slate-400" data-id="element-97" data-mp="3ggtymjf7hl5r">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-4 px-4 text-center text-sm sm:flex-row sm:justify-between sm:px-6 sm:text-left" data-id="element-98" data-mp="32o4d0g3lai96">
        <p data-id="element-99" data-mp="36pzebklisvmy">
          <span className="font-semibold text-white" data-id="element-100" data-mp="36nd57gize82m">{site.productName}</span> · {site.company} ·{' '}
          <a href={`https://${site.domain}`} className="transition-colors duration-150 ease-out hover:text-white" data-id="element-101" data-mp="3ucxmluzhkx9s">
            {site.domain}
          </a>
        </p>
        <a href={site.whatsappUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 font-semibold text-success-light transition-colors duration-150 ease-out hover:text-white" data-id="element-102" data-mp="3ldkcd03jg4o0">
          <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-103" data-mp="2ey0akc250ojr" />
          Soporte por WhatsApp
        </a>
      </div>
      <p className="mt-6 text-center text-xs text-slate-500" data-id="element-104" data-mp="3l8qy89n2utu3">
        © {new Date().getFullYear()} {site.company}. Todos los derechos reservados.
      </p>
    </footer>;
}